<template>
  <div>
    <v-container class="py-10">
      <v-row class="align-center">
        <v-col cols="12" lg="6" class="pr-10">
          <h2>9. Bias-Check</h2>
          <p></p>
          <p style="color: green">
            <b>UPDATE</b>
          </p>
        </v-col>
        <v-col cols="12" lg="6">
          <highcharts :options="chartOptions" ref="chart"></highcharts>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Biascheck",
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: "Kennen Sie die folgenden Technologien?"
        },
        plotOptions: {
          series: {
            dataLabels: {
              useHTML: true,
              enabled: true,
              formatter: function() {
                return this.series.marker;
              }
            }
          }
        },
        xAxis: {
          categories: [
            "Cookie",
            "Jpg",
            "Zippen",
            "Bcc bei E-Mails",
            "HTML",
            "Shareware",
            "Malware",
            "Weblog",
            "VPN",
            "Server",
            "Cloud",
            "Blog",
            "Firewall",
            "Proxypod",
            "JFW",
            "Filtibly"
          ]
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Prozent der Organisationen: Ja"
          }
        },
        tooltip: {
          valueSuffix: "%"
        },
        colors: ["#546825"],
        series: [
          {
            showInLegend: false,
            name: "",
            data: [
              96.4,
              96.1,
              92.7,
              95.5,
              97.1,
              82.6,
              91.1,
              75.5,
              81.2,
              98.3,
              98.2,
              96.8,
              98.4,
              13.9,
              7.1,
              5.2
            ]
          }
        ],
        exporting: {
          enabled: true,
          fallbackToExportServer: false
        }
      };
    }
  },
  methods: {
    downloadJPEG() {
      this.$refs.chart.chart.exportChart({ type: "image/jpeg" });
    },
    downloadSVG() {
      this.$refs.chart.chart.exportChart({ type: "image/svg+xml" });
    },
    downloadPDF() {
      this.$refs.chart.chart.exportChart({ type: "application/pdf" });
    },
    downloadCSV() {
      this.$refs.chart.chart.downloadCSV();
    }
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
  min-height: 20em;
}
.component-color {
  background-color: #fff;
}
</style>
